import * as angular from 'angular';

(function () {
    'use strict';

    angular.module('app').directive('telephoneValidator', telephoneValidator);

    /**
     * Validate telephone numbers
     * The validation has been taken from the JSF validator PhoneNumberValidator class
     *
     * @author flzemke.btc
     * @ngInject
     */
    function telephoneValidator() {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function (scope, element, attr, ctrl) {
                function telephoneValidator(ngModelValue) {
                    if (!ngModelValue) {
                        ctrl.$setValidity('telephoneValidator', true);
                        return ngModelValue;
                    }

                    var telephonePattern = /[0-9 \-()/+]*/;
                    var matches = ngModelValue.match(telephonePattern);

                    if (!matches) {
                        ctrl.$setValidity('telephoneValidator', false);
                        return ngModelValue;
                    }

                    ctrl.$setValidity(
                        'telephoneValidator',
                        matches.length === 1 &&
                            matches[0].length === ngModelValue.length
                    );

                    return ngModelValue; // return to display value to the user
                }

                ctrl.$parsers.push(telephoneValidator);
            }
        };
    }
})();
